import helpCenter from './modules/helpCenter';
import community from './modules/community';
import tickets from './modules/tickets';
import user from './modules/user';
import search from './modules/search';
import survey from './modules/survey';
import session from './modules/session';

export default {
  helpCenter,
  community,
  tickets,
  user,
  search,
  survey,
  session,
};
